/* configuration */
import Modernizr from 'modernizr';
import mergeDeepLeft from 'ramda/src/mergeDeepLeft';
import mediaQuery from '@util/media-queries';
import {$CONTENT_WINDOW} from '@config/selectors';
import namespace from './namespace';

(function ( upi ) {
    const
        pathsConfig = namespace( 'paths' ),
        upiConfig = namespace( 'conf' ),
        envConfig = namespace( 'env' );

    upi.paths = mergeDeepLeft( pathsConfig, {
        ORIGIN: 'https://www.ultradent.com',
        ORIGIN_CDN: 'https://www.ultradent.com',
        SITE_URL: '/',
        IMAGES_ORIGIN: 'https://images.ultradent.com',
        IMAGES_ORIGIN_CDN: 'https://images.ultradent.com',
        STORE_ORIGIN: '/',
        STORE_URL: '/checkout'
    } );

    upi.paths = {
        ...upi.paths,
        LOGIN_URL: `${upi.paths.SITE_URL}login`,
        WRITE_REVIEW_URL: `${upi.paths.SITE_URL}Reviews/CreateReview`,
        EDIT_REVIEW_URL: `${upi.paths.SITE_URL}Reviews/EditReview`,
        ORDER_DETAILS_URL: `${upi.paths.SITE_URL}order-details`
    };

    upi.conf = mergeDeepLeft( upiConfig, {
        locale: 'en-us',
        features: {
            SearchSuggestions: false,
            FreeShippingMsg: true,
            MiniCart: false
        },
        hasPriceRestrictions: false,
        SCROLL_CONTEXT: Modernizr.mq( mediaQuery.min['screenLarge'] ) ?
            $CONTENT_WINDOW :
            document.scrollingElement || document.documentElement,
        IMAGE: {
            _404: '/images/no-image-available.png'
        },
        SHOW_HOLIDAY_SHIPPING_NOTICE: Date.now() > new Date( 'Dec 20, 2018' ) && Date.now() < new Date( 'Jan 3, 2019' ),
        HOLIDAY_SHIPPING_NOTICE: 'Due to our holiday schedule, orders placed after Noon December 22 will be shipped and billed beginning January 2, 2019.',
        phoneTollFree: '1-888-230-1420',
        phoneEquipmentRepairs: '1-801-553-4574',
        FREE_SHIPPING_GOAL: 295,
        REGISTRATION_ERROR_MSG: `We are unable to complete this request at this time. Please contact our customer service at ${upi.conf.phoneTollFree}`,
        LOGIN_MSG: 'To view prices and items you may have added from a previous visit please',
        SESSION_TIMEOUT: 'Sorry, your current session has expired. Please login to continue...',
        GENERIC_SERVICE_ERROR: 'An error occurred while attempting to perform this action. Please try again later.',
        UNKNOWN_SUBMISSION_ERROR: `There was an unknown error while submitting this request. Please verify the information you provided and try again. If the problem persists please contact our customer service at ${upi.conf.phoneTollFree}`
    } );

    upi.env = mergeDeepLeft( envConfig, {
        IS_RETINA: 'devicePixelRatio' in window && window.devicePixelRatio > 1,
        IS_STORE: /(\/checkout)/.test( window.location.host ),
        IS_ENUS: upi.conf.locale.toLowerCase() === 'en-us'
    } );

})( window.upi );
